import { Files, Upload } from 'lucide-react';
import { useState } from 'react';

import FacilityAssetsTab from '@/components/FacilityAssetsTab';
import FacilityTemplatesTab from '@/components/FacilityTemplatesTab';
import FacilityUploadTab from '@/components/FacilityUploadTab';

type TabType = 'assets' | 'upload' | 'templates';

export default function FacilityTabs() {
  const [activeTab, setActiveTab] = useState<TabType>('assets');

  const tabs = [
    {
      id: 'assets' as TabType,
      label: 'Assets & Slideshow',
      icon: Files,
      description: 'Manage assets and slideshow configuration'
    },
    {
      id: 'upload' as TabType,
      label: 'Upload',
      icon: Upload,
      description: 'Upload new assets'
    },
    {
      id: 'templates' as TabType,
      label: 'Templates',
      icon: Files,
      description: 'Manage and apply templates'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'assets':
        return <FacilityAssetsTab />;
      case 'upload':
        return <FacilityUploadTab />;
      case 'templates':
        return <FacilityTemplatesTab />;
      default:
        return <FacilityAssetsTab />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="border-b border-border">
        <nav className="flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors
                  ${isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
                  }
                `}
                aria-current={isActive ? 'page' : undefined}
              >
                <Icon className={`
                  -ml-0.5 mr-2 h-5 w-5 transition-colors
                  ${isActive ? 'text-primary' : 'text-muted-foreground group-hover:text-foreground'}
                `} />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Description */}
      <div className="text-sm text-muted-foreground">
        {tabs.find(tab => tab.id === activeTab)?.description}
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {renderTabContent()}
      </div>
    </div>
  );
}
